module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white-ae0f251fa64c1ba5c7c7184100785088.png";